// extracted by mini-css-extract-plugin
module.exports = {"chart_heading":"Charts_chart_heading__GzB9F"};